import { Button, Spinner } from 'react-bootstrap';

interface Props {
    isSubmit?: boolean;
    isLoading: boolean;
    isDisable?: boolean;
}

export default function SaveButton({
    isLoading,
    isDisable = false,
    isSubmit = true,
}: Props) {
    return (
        <Button
            type={isSubmit ? 'submit' : 'button'}
            variant='primary'
            disabled={isLoading || isDisable}
        >
            {isLoading && (
                <Spinner animation='border' size='sm' role='status'>
                    <span className='visually-hidden'>Guardando...</span>
                </Spinner>
            )}
            {isLoading ? ' Guardando...' : 'Guardar'}
        </Button>
    );
}
